import { useRevalidator } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { Button } from '@oysterjs/ui/button';

import { LibraryListEmptyState } from './library-list-empty-state';

/** Shown in place of a list or page when its loader fails; Try again reruns the loader. */
export const LibraryListLoadError = ({ title }: { title: string }) => {
  const revalidator = useRevalidator();

  return (
    <LibraryListEmptyState
      icon={ExclamationTriangleIcon}
      title={title}
      description="Check your connection and try again. If it keeps happening, contact support."
      action={
        <Button
          color="white"
          loading={revalidator.state === 'loading'}
          onClick={() => revalidator.revalidate()}
        >
          Try again
        </Button>
      }
    />
  );
};
